import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter-debtor-favorite',
  templateUrl: './filter-debtor-favorite.component.html',
  styleUrls: ['./filter-debtor-favorite.component.scss']
})
export class FilterDebtorFavoriteComponent {
  @Output() geFilter: EventEmitter<string> = new EventEmitter();
  public formFilter!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.formFilter = this.fb.group({
      generalFilter: [''],
    });
  }
  
  filtroGeneral(event: any) {
    const filterValue = event.target.value;
    this.geFilter.emit(filterValue);
  }

  filtroGeneralTemporizado(event: any) {
    setTimeout(() => {
      const filterValue = event.target.value;
      this.geFilter.emit(filterValue);
    }, 2000);
  }

}
